import { useQuery } from '@tanstack/react-query';

import type { NoteWithTemplateData } from '../../noteTemplate';
import { useVideaNotesApi } from '../context';

import { getVideaNoteByIdQueryKey } from './queryKeys';

export const useNoteById = (
  clinicalNoteId: string | undefined,
  enabled: boolean,
) => {
  const { fetchNoteById, getContext } = useVideaNotesApi();
  const { practiceId, organizationId } = getContext();

  return useQuery({
    queryKey: getVideaNoteByIdQueryKey(
      organizationId,
      practiceId,
      clinicalNoteId,
    ),
    queryFn: async (): Promise<NoteWithTemplateData | null> => {
      if (!clinicalNoteId) {
        return null;
      }

      return fetchNoteById(clinicalNoteId);
    },
    enabled: !!clinicalNoteId && enabled,
  });
};
